import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Button, Icons, TextInput, Spinner } from '../';
const DELAY = 250;
export const AutoSearch = ({ searchResults = [], resultsNotFound = false, onAddressChange, onSelectedResult, onClearResult, overwriteInputValue, autoFocusOnOpen = false, hideClearBtnOnSelect = false, isLoading = false, disabled = false, translationData = {
    placeholder: 'Search',
    notFound: 'Not Found',
}, }) => {
    const { placeholder, notFound: notFoundText } = translationData;
    const [init, setInit] = useState(false);
    const [isClearBtnHidden, updateIsClearBtnHidden] = useState(hideClearBtnOnSelect);
    const [active, setActive] = useState(false);
    const [address, updateAddress] = useState('');
    const [highlight, updateHighligh] = useState(0);
    const [inputRef, updateInputRef] = useState();
    const onChange = (value) => {
        updateAddress(value);
        if (value && value.trim() !== address.trim()) {
            if (onAddressChange) {
                onAddressChange(value);
            }
        }
    };
    const selectAddress = (address) => {
        if (address && typeof address.formattedAddress !== 'undefined') {
            updateAddress(address.formattedAddress);
            if (onSelectedResult) {
                onSelectedResult(address);
            }
        }
    };
    const clearResults = () => {
        updateAddress('');
        if (inputRef) {
            inputRef.focus({ preventScroll: true });
        }
        if (onClearResult) {
            onClearResult();
        }
    };
    const hideDropdown = () => setActive(false);
    const showDropdown = () => setActive(true);
    useEffect(() => {
        if (inputRef && autoFocusOnOpen && !init) {
            if (inputRef) {
                inputRef.focus({ preventScroll: true });
            }
            setInit(true);
        }
    }, [inputRef]);
    useEffect(() => {
        if (overwriteInputValue) {
            updateAddress(overwriteInputValue);
        }
    }, [overwriteInputValue]);
    useEffect(() => {
        if (hideClearBtnOnSelect) {
            searchResults.length ? updateIsClearBtnHidden(false) : updateIsClearBtnHidden(true);
        }
    }, [searchResults]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextInput, { className: "auto-search", placeholder: placeholder, value: address, autoComplete: "none", disabled: disabled, accessInputRef: (ref) => {
                updateInputRef(ref);
            }, onChange: ({ target }) => {
                onChange(target.value || '');
            }, onPressEnter: () => {
                selectAddress(searchResults[highlight]);
            }, onEscape: () => {
                clearResults();
            }, onArrowUp: () => {
                if (highlight > 0) {
                    updateHighligh(highlight - 1);
                }
            }, onArrowDown: () => {
                if (highlight < searchResults.length - 1) {
                    updateHighligh(highlight + 1);
                }
            }, onFocus: () => setTimeout(() => showDropdown(), DELAY), onBlur: () => setTimeout(() => hideDropdown(), DELAY) },
            React.createElement(React.Fragment, null,
                !isLoading && address.length && !isClearBtnHidden ? (React.createElement(Button, { className: "auto-search--clear", style: "subtle", leftIcon: React.createElement(Icons, { iconName: "ic-ui-cancel-sm" }), iconOnly: true, onClick: clearResults })) : null,
                React.createElement(Spinner, { className: "auto-search--loading", size: "s", loading: isLoading }),
                active && searchResults.length ? (React.createElement("ul", { className: `auto-search_results` }, !resultsNotFound &&
                    searchResults.map((item, index) => (React.createElement("li", { key: item.formattedAddress, className: classNames('auto-search_results_item', {
                            'auto-search_results_item--highlight': index === highlight,
                        }), onClick: () => {
                            selectAddress(item);
                        }, onMouseOver: () => {
                            updateHighligh(index);
                        } }, item.formattedAddress))))) : null,
                resultsNotFound && (React.createElement("ul", { className: `auto-search_results` },
                    React.createElement("li", { className: classNames('auto-search_results_item', {
                            'auto-search_results_item--error': true,
                        }) }, notFoundText)))))));
};
//# sourceMappingURL=AutoSearch.js.map